import React from 'react';
import { List, Rows3 } from 'lucide-react';
import { financialEntryRoutes } from './FinancialEntries/routes';
import { dreLineRoutes } from './DreLines/routes';

export const FINANCIAL_TAB_ENTRY = 'entry';
export const FINANCIAL_TAB_DRE = 'dre-line';

export const financialSectionTabs = [
  {
    key: FINANCIAL_TAB_ENTRY,
    path: financialEntryRoutes.list,
    label: 'Lançamentos',
    icon: <List size={12.8} />,
  },
  {
    key: FINANCIAL_TAB_DRE,
    path: dreLineRoutes.list,
    label: 'Linhas do DRE',
    icon: <Rows3 size={12.8} />,
  },
];
